define(
    'atn/toasterRegistry',['lodash', 'knockout', './globals', 'common/browserFeatureSupport'],
    function(_, ko, globals, browserFeatureSupport) {
    
    'use strict';
    var toasterRegistryList = ko.observableArray([]);

    globals.reInitAt.subscribe(function() {
        clean();
    });

    var showToasterMessages = ko.observable(false);


    showToasterMessages.subscribe(function(value){
        if(!value){
            clean();
        }
    });

    toasterRegistryList.subscribe(handleRegistryModification, null, 'arrayChange');

    return {
        addToasterMessage: addMessagesToRegistry,
        toasterRegistryList: toasterRegistryList,
        showToasterMessages: showToasterMessages
    };

    /**
     * [clean clean the registry]
     * @return {undefined}
     */
    function clean() {
        toasterRegistryList([]);
    }

    /**
     * [addMessagesToRegistry add a message or array of message to the registry]
     * @param {[type]} messages [description]
     */
    function addMessagesToRegistry(messages) {
        if(_.isArray(messages)){
            _.forEach(messages,function(message){
                toasterRegistryList.push(message);
            });    

        } else {
            toasterRegistryList.push(messages);
        }
    }


    function handleRegistryModification(changesArray){
        /**
         * Ensure that additionDone is true 
         * only when atleast one item is added
         * to the toaster list
         */
        
        var additionDone = _.reduce(
            changesArray,
            function(result, changedItem){
                if(changedItem.status === 'added' && changedItem.value.length){
                    result = result || true;
                }
                return result;
            },
            false
        );

        if(additionDone){
            showToasterMessages(true);
        }
    }

    
});
